function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { appActions } from '../../reducers/app.reducer';
import OurPurposeP from './OurPurposeP.react';
import OurPurposeCounter from './OurPurposeCounter.react';
import P1Main from './page1/P1Main.react';
import P1Belt from './page1/P1Belt.react';
import Plant from './plant/Plant.react';
import P2Title from './page2/P2Title.react';
import P2Plant from './page2/P2Plant.react';
import P3Consumes from './page3/P3Consumes.react';
import P3Billions from './page3/P3Billions.react';
import P3Link from './page3/P3Link.react';
import P4Header from './page4/P4Header.react';
import P4Loader from './page4/P4Loader.react';
import P4Body from './page4/P4Body.react';
import P4Landfill from './page4/P4Landfill.react';
import P5Main from './page5/P5Main.react';
import P6Main from './page6/P6Main.react';
import P7Main from './page7/P7Main.react';
import P7Belt from './page7/P7Belt.react';
import P7Info from './page7/P7Info.react';
import P8 from './page8/P8.react';
import P8Header from './page8/P8Header.react';
import P8Belt from './page8/P8Belt.react';
import P9Header from './page9/P9Header.react';
import P9Main from './page9/P9Main.react';
import P9BG from './page9/P9BG.react';
import P10 from './page10/P10.react';
import P10Blocks from './page10/P10Blocks.react';
import P10Video from './page10/P10Video.react';
var OurPurpose = function OurPurpose(_ref) {
  var gaEventAction = _ref.gaEventAction;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    page = _useState2[0],
    setPage = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loaded = _useState4[0],
    setLoaded = _useState4[1];
  useEffect(function () {
    var img = new window.Image();
    img.onload = function () {
      var img = new window.Image();
      img.onload = function () {
        var img = new window.Image();
        img.onload = function () {
          var img = new window.Image();
          img.onload = function () {
            var img = new window.Image();
            img.onload = function () {
              var img = new window.Image();
              img.onload = function () {
                setLoaded(true);
                // $('.purpose__loader').css({ opacity: 0 });
              };
              img.src = '/public/images/our-purpose/p1/this-state-of-the-art-facility-has-revolutionized@3x.png';
            };
            img.src = '/public/images/our-purpose/p1/a-historic-project-was-completed-in-conjunction-with-the-nys.png';
          };
          img.src = '/public/images/our-purpose/p1/in-2019-posillico-materials-opened-the-largest-and-most-advanc.png';
        };
        img.src = '/public/images/our-purpose/p1/dirt@3x.png';
      };
      img.src = '/public/images/our-purpose/p1/belt-sm.png';
    };
    img.src = '/public/images/our-purpose/p1/belt-lg.png';
  }, []);
  useEffect(function () {
    gaEventAction({
      category: 'Our Purpose Slide View',
      action: 'change',
      label: "Slide ".concat(page)
    });
  }, [page]);
  return /*#__PURE__*/React.createElement("div", {
    className: "purpose"
  }, /*#__PURE__*/React.createElement("div", {
    className: "purpose__overlay"
  }), /*#__PURE__*/React.createElement(OurPurposeP, {
    page: page
  }), loaded && /*#__PURE__*/React.createElement(OurPurposeCounter, {
    onPageChange: setPage
  }), loaded && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "aspectratio"
  }, /*#__PURE__*/React.createElement(P1Main, {
    page: page
  }), /*#__PURE__*/React.createElement(Plant, {
    page: page
  }), /*#__PURE__*/React.createElement(P2Title, {
    page: page
  }), /*#__PURE__*/React.createElement(P2Plant, {
    page: page
  }), /*#__PURE__*/React.createElement(P7Main, {
    page: page
  }), /*#__PURE__*/React.createElement(P7Info, {
    page: page
  }), /*#__PURE__*/React.createElement(P8, {
    page: page
  }), /*#__PURE__*/React.createElement(P8Header, {
    page: page
  }), /*#__PURE__*/React.createElement(P3Consumes, {
    page: page
  }), /*#__PURE__*/React.createElement(P3Billions, {
    page: page
  }), /*#__PURE__*/React.createElement(P3Link, {
    page: page
  }), /*#__PURE__*/React.createElement(P4Header, {
    page: page
  }), /*#__PURE__*/React.createElement(P4Loader, {
    page: page
  }), /*#__PURE__*/React.createElement(P4Body, {
    page: page
  }), /*#__PURE__*/React.createElement(P4Landfill, {
    page: page
  }), /*#__PURE__*/React.createElement(P5Main, {
    page: page
  }), /*#__PURE__*/React.createElement(P6Main, {
    page: page
  }), /*#__PURE__*/React.createElement(P9Header, {
    page: page
  }), /*#__PURE__*/React.createElement(P9Main, {
    page: page
  }), /*#__PURE__*/React.createElement(P10, {
    page: page
  }), /*#__PURE__*/React.createElement(P10Blocks, {
    page: page
  })), /*#__PURE__*/React.createElement(P8Belt, {
    page: page
  }), /*#__PURE__*/React.createElement(P1Belt, {
    page: page
  }), /*#__PURE__*/React.createElement(P7Belt, {
    page: page
  }), /*#__PURE__*/React.createElement(P10Video, {
    page: page
  }), /*#__PURE__*/React.createElement(P9BG, {
    page: page
  })));
};
var mdtp = {
  gaEventAction: appActions.gaEvent
};
export default connect(null, mdtp)(OurPurpose);